import React from 'react';
import { Box, Typography } from '@material-ui/core';
import cx from 'classnames';

import { translate } from '../../../../utils/helpers';
import { Test } from '../../const';
import { PathwayTestItem } from '../PathwayTestItem';
import useStyles from './styles';

interface PathwayTestInformationProps {
  tests: Test[];
  wrapperClass?: string;
}

const PathwayTestInformation: React.FC<PathwayTestInformationProps> = ({ tests, wrapperClass }) => {
  const classes = useStyles();

  return (
    <Box className={cx(classes.wrapper, wrapperClass)}>
      <Typography className={classes.title}>
        {tests.length > 1 || !tests.length
          ? translate('page.pathway.tests')
          : translate('page.pathway.test')}
      </Typography>
      <ul className={classes.itemsWrapper}>
        {tests.map((item) => (
          <PathwayTestItem
            key={item.id}
            id={item.id}
            title={item.title}
            canPassTest={item.canPassTest}
            testPassed={item.testPassed}
          />
        ))}
      </ul>
    </Box>
  );
};

export default PathwayTestInformation;
